import React from "react"

import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string"
import FieldDate from "../../fields3/generic/datetime/date/date"
import FieldNumber from "../../fields3/generic/number/number"
import FieldGoalHealth from "../../fields3/system/goal/health/health"
import FieldIconWithColor from "../../fields3/generic/icon-with-color/icon-with-color"
import FieldGoalType from "../../fields3/system/goal/type/type"
import FieldProject from "../../fields3/generic/entity/project/project"
import FieldAssignees from "../../fields3/generic/assignees/assignees"
import FieldDateStartDue from "../../fields3/generic/datetime/date-due/date-due"
import {FieldProjects_ViewModes} from "../../fields3/generic/entity/projects/projects"
import FieldDateRange from "../../fields3/generic/datetime/date-range/date-range"
import FieldToggle from "../../fields3/generic/boolean/toggle/toggle"

export default class GoalFields extends FieldsCollection {

    constructor() {

        const fieldsConfig = [
            { fieldId: 'name',                      type: FieldType.STRING,     label: 'Name',      placeholder: 'New goal'},

            { fieldId: 'icon',                      type: FieldType.STRING,     label: 'Icon' },
            { fieldId: 'color',                     type: FieldType.STRING,     label: 'Color' },
            { fieldId: 'iconWithColor',             type: FieldType.ICON_WITH_COLOR },

            { fieldId: 'startDue',                  type: FieldType.DATE_START_DUE },
            { fieldId: 'startEnd',                  type: FieldType.DATE_RANGE },

            { fieldId: 'startDate',                 type: FieldType.DATE,       label: 'Start date' },
            { fieldId: 'endDate',                   type: FieldType.DATE,       label: 'End date' },
            { fieldId: 'duration',                  type: FieldType.NUMBER,     label: 'Duration',              minValue: 0,    maxValue: 365*10 },
            { fieldId: 'durationWorkdays',          type: FieldType.NUMBER,     label: 'Duration, workdays',    minValue: 0,    maxValue: 365*10 },

            { fieldId: 'description',               type: FieldType.STRING,     label: 'Description' },

            { fieldId: 'userIds',                   type: FieldType.ASSIGNEES,  label: 'Users'},
            { fieldId: 'assigneeUserIds',           type: FieldType.ASSIGNEES,  label: 'Assignees'},
            // { fieldId: 'allAssigneeUserIds',        type: FieldType.GOAL_ASSIGNEES, placeholder: '' },
            {
                fieldId             : 'ownerUserIds',
                type                : FieldType.ASSIGNEES,
                label               : 'Owners',
                selectionIsMandatory: true
            }, {
                fieldId         : 'projectId',
                type            : FieldType.PROJECT,
                label           : 'Project',
                viewMode        : FieldProjects_ViewModes.PROJECTS,
                noValueOption   : false,
                placeholderIcon : <div className="ui5-ico-16 i5-project m-r-5"/>,
                clearButton     : true,
            },

            { fieldId: 'currentValue',              type: FieldType.NUMBER,         label: 'Current value' },
            { fieldId: 'targetValue',               type: FieldType.NUMBER,         label: 'Target value' },

            { fieldId: 'type',                      type: FieldType.GOAL_TYPE,      label: 'Type' },
            { fieldId: 'health',                    type: FieldType.GOAL_HEALTH,    label: 'Health' },

            // for history view
            { fieldId: 'parentGoalId',              type: FieldType.STRING,         label: 'Parent goal' },
            { fieldId: 'isArchived',                type: FieldType.TOGGLE,         label: 'Is Archived' },
        ]

        super(fieldsConfig, EntityType.GOAL)
    }

    get name()              :FieldString { return this.get('name') as FieldString }
    get icon()              :FieldString { return this.get('icon') as FieldString }
    get startDue()          :FieldDateStartDue { return this.get('startDue') as FieldDateStartDue }
    get startEnd()          :FieldDateRange { return this.get('startEnd') as FieldDateRange }
    get startDate()         :FieldDate { return this.get('startDate') as FieldDate }
    get endDate()           :FieldDate { return this.get('endDate') as FieldDate }
    get duration()          :FieldNumber { return this.get('duration') as FieldNumber}
    get durationWorkdays()  :FieldNumber { return this.get('durationWorkdays') as FieldNumber}
    get description()       :FieldString { return this.get('description') as FieldString }
    get userIds()           :FieldAssignees { return this.get('userIds') as FieldAssignees }
    get assigneeUserIds()   :FieldAssignees { return this.get('assigneeUserIds') as FieldAssignees }
    // get allAssigneeUserIds():FieldGoalAssignees { return this.get('allAssigneeUserIds') as FieldGoalAssignees }
    get projectId()         :FieldProject { return this.get('projectId') as FieldProject }

    get ownerUserIds()      :FieldAssignees { return this.get('ownerUserIds') as FieldAssignees }
    get type()              :FieldGoalType { return this.get('type') as FieldGoalType }
    get health()            :FieldGoalHealth { return this.get('health') as FieldGoalHealth }
    get currentValue()      :FieldNumber { return this.get('currentValue') as FieldNumber }
    get targetValue()       :FieldNumber { return this.get('targetValue') as FieldNumber }

    get iconWithColor()     :FieldIconWithColor { return this.get('iconWithColor') as FieldIconWithColor }

    // for history view
    get parentGoalId()      :FieldString { return this.get('parentGoalId') as FieldString }
    get isArchived()        :FieldToggle { return this.get('isArchived') as FieldToggle }
}
